<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div>
    <div class="field">
      <FieldLabel
        :label="$t('dashboardAdmin.blockEditor.chartType')"
        :help="$t('dashboardAdmin.blockEditor.help.chartType')"
      />
      <PrimeSelect
        :model-value="config.type"
        :options="chartTypes"
        class="select-full"
        @update:model-value="updateChartType"
      />
    </div>
    <div class="field">
      <FieldLabel
        :label="$t('dashboardAdmin.blockEditor.chartDataJson')"
        :help="$t('dashboardAdmin.blockEditor.help.chartDataJson')"
        :example="$t('dashboardAdmin.blockEditor.examples.chartDataJson')"
      />
      <PrimeTextarea
        :model-value="chartDataJson"
        rows="8"
        class="textarea-json"
        @click="$emit('open-json-editor', 'chart')"
        readonly
        :placeholder="$t('dashboardAdmin.blockEditor.clickToEdit')"
      />
      <small class="hint-text">{{
        $t("dashboardAdmin.blockEditor.jsonFormat")
      }}</small>
    </div>
  </div>
</template>

<script>
import Select from "primevue/select";
import Textarea from "primevue/textarea";
import FieldLabel from "@/components/dashboard/editor/FieldLabel.vue";

export default {
  name: "ChartConfig",
  components: {
    PrimeSelect: Select,
    PrimeTextarea: Textarea,
    FieldLabel,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    chartDataJson: {
      type: String,
      default: "",
    },
  },
  emits: ["update:config", "open-json-editor"],
  data() {
    return {
      chartTypes: ["pie", "bar", "line", "doughnut", "radar", "polarArea"],
    };
  },
  methods: {
    updateChartType(newType) {
      this.$emit("update:config", {
        ...this.config,
        type: newType,
      });
    },
  },
};
</script>

<style scoped>
.field {
  margin-bottom: 1rem;
}

.select-full {
  width: 100%;
}

.textarea-json {
  width: 100%;
  font-family: "Courier New", Courier, monospace;
  font-size: 0.875rem;
  cursor: pointer;
}

.hint-text {
  color: var(--p-text-muted-color);
}
</style>
